import { Button } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import type { CSSProperties, ReactNode } from "react";

import IconAlertCircle from "@src/assets/icons/tabler/alert-circle.svg?react";
import IconCheck from "@src/assets/icons/tabler/check.svg?react";
import { NavLink } from "react-router-dom";

export function showSuccessNotification(
	title: string,
	message: ReactNode,
	button?: {
		text: string;
		to?: string;
		onClick?: () => void;
	},
) {
	notifications.show({
		title,
		message: button ? (
			<>
				<div className="mb-1">{message}</div>
				{button.to ? (
					<NavLink to={button.to}>
						<Button variant="light" color="#149868" className="font-medium">
							{button.text}
						</Button>
					</NavLink>
				) : (
					<Button
						variant="light"
						color="#149868"
						className="font-medium"
						onClick={() => {
							notifications.clean();
							button.onClick?.();
						}}
					>
						{button.text}
					</Button>
				)}
			</>
		) : (
			message
		),
		color: "#149868",
		position: "top-right",
		radius: "md",
		withBorder: true,
		icon: <IconCheck />,
		className: "border-[#149868]",
	});
}

export function showErrorNotification(title: string, message: string) {
	notifications.show({
		title,
		message,
		color: "var(--ui-color-danger)",
		position: "top-right",
		radius: "md",
		withBorder: true,
		icon: <IconAlertCircle className="w-8 h-8" />,
		className: "border-danger",
	});
}

export function showNetworkErrorNotification() {
	showErrorNotification("Error", "Something went wrong, please try later");
}

const VIEW_ONLY_PASTE_NOTIFICATION_ID = "view-only-paste";

export function showViewOnlyPasteNotification() {
	notifications.show({
		id: VIEW_ONLY_PASTE_NOTIFICATION_ID,
		title: "View only",
		message: "You don't have permission to edit this board.",
		color: "var(--ui-color-warning)",
		position: "top-right",
		radius: "md",
		withBorder: true,
		icon: <IconAlertCircle className="w-8 h-8" />,
		className: "border-warning",
	});
}

export function showGuestPersonaNotification(
	name: string,
	color: string,
): void {
	notifications.show({
		title: "You're joining as",
		message: (
			<div className="flex items-center gap-2">
				<div
					className="w-3 h-3 rounded-full shrink-0"
					style={{ backgroundColor: color }}
				/>
				<span className="font-medium">{name}</span>
			</div>
		),
		autoClose: 3000,
		position: "top-right",
		radius: "md",
		withBorder: true,
		color: "gray",
		style: {
			maxWidth: 220,
			"--notification-color": color,
		} as CSSProperties,
	});
}
